import { Link } from 'react-router-dom';
import { ArrowRight, ExternalLink } from 'lucide-react';
import Reveal from '../components/Reveal';
import IntroLogoOverlay from '../components/IntroLogoOverlay';
import usePageMeta from '../hooks/usePageMeta';

const YEAR = new Date().getFullYear();

export default function Entry() {
  usePageMeta(
    'RangeSafe | Choose Your Destination',
    'RangeSafe stove safety knobs — shop retail for your home or explore commercial solutions for your properties and facilities.'
  );
  return (
    <>
      <IntroLogoOverlay />
      <main
        className="relative flex min-h-[100svh] flex-col px-5 py-8 sm:px-8 sm:py-10"
        data-testid="entry-page"
      >
        <div className="flex flex-1 flex-col items-center justify-center py-12">
          <Reveal className="relative z-10 w-full">
            <div className="flex flex-col items-center text-center">
              <img
                src="/assets/brand/rangesafe-logo.png"
                alt="RangeSafe"
                className="h-20 w-auto sm:h-24"
                data-testid="entry-logo"
              />
              <h1 className="mt-8 max-w-lg text-lg leading-relaxed text-dim sm:text-xl">
                Select the website below that best matches your needs
              </h1>
            </div>
          </Reveal>

          <div className="mt-12 grid w-full max-w-5xl gap-6 md:grid-cols-2">
            <Reveal delay={0.08} className="relative z-10 h-full">
              <section
                aria-labelledby="entry-retail-title"
                className="flex h-full flex-col border border-line bg-panel/80 p-8 sm:p-9"
                data-testid="entry-retail-card"
              >
                <p className="font-mono text-xs uppercase tracking-[0.3em] text-mute">For your home</p>
                <h2
                  id="entry-retail-title"
                  className="mt-3 font-display text-3xl font-bold uppercase leading-none tracking-tight text-white sm:text-4xl"
                >
                  RangeSafe<br />Retail Customers
                </h2>
                <p className="mt-4 flex-1 text-base leading-relaxed text-silver">
                  Shop stove safety knobs for your home.
                </p>
                <a
                  href="https://rangesafe.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-8 inline-flex h-14 w-full max-w-xs items-center justify-start gap-2 self-start border border-[#B91C1C] bg-[#B91C1C] px-7 font-mono text-xs font-medium uppercase tracking-[0.22em] text-white transition-colors hover:bg-accent hover:border-accent"
                  data-testid="entry-retail-button"
                >
                  Shop Retail
                  <ExternalLink className="h-4 w-4" aria-hidden="true" />
                </a>
              </section>
            </Reveal>

            <Reveal delay={0.16} className="relative z-10 h-full">
              <section
                aria-labelledby="entry-commercial-title"
                className="flex h-full flex-col border border-line bg-panel/80 p-8 sm:p-9"
                data-testid="entry-commercial-card"
              >
                <p className="font-mono text-xs uppercase tracking-[0.3em] text-mute">
                  For your properties or facilities
                </p>
                <h2
                  id="entry-commercial-title"
                  className="mt-3 font-display text-3xl font-bold uppercase leading-none tracking-tight text-white sm:text-4xl"
                >
                  RangeSafe<br />Commercial Solutions
                </h2>
                <p className="mt-4 flex-1 text-base leading-relaxed text-silver">
                  Explore stove safety solutions for your commercial properties <span className="whitespace-nowrap">and facilities.</span>
                </p>
                <Link
                  to="/commercial"
                  className="mt-8 inline-flex h-14 w-full max-w-xs items-center justify-start gap-2 self-start border border-[#B91C1C] bg-[#B91C1C] px-7 font-mono text-xs font-medium uppercase tracking-[0.22em] text-white transition-colors hover:bg-accent hover:border-accent"
                  data-testid="entry-commercial-button"
                >
                  Explore Commercial
                  <ArrowRight className="h-4 w-4" aria-hidden="true" />
                </Link>
              </section>
            </Reveal>
          </div>
        </div>

        <p className="relative z-10 text-center font-mono text-[10px] uppercase tracking-[0.18em] text-mute">
          © {YEAR} RangeSafe
        </p>
      </main>
    </>
  );
}
